var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('map-component',{attrs:{"marker":_vm.marker,"center":_vm.mapCenter,"zoom":_vm.zoom,"tilesUrl":_vm.tilesUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }